/* tslint:disable */
/* eslint-disable */
/**
 * My Title
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ConfigurationHealthClassResponse } from './ConfigurationHealthClassResponse';
import {
    ConfigurationHealthClassResponseFromJSON,
    ConfigurationHealthClassResponseFromJSONTyped,
    ConfigurationHealthClassResponseToJSON,
    ConfigurationHealthClassResponseToJSONTyped,
} from './ConfigurationHealthClassResponse';

/**
 * 
 * @export
 * @interface ConfigurationHealthResponse
 */
export interface ConfigurationHealthResponse {
    /**
     * 
     * @type {Array<ConfigurationHealthClassResponse>}
     * @memberof ConfigurationHealthResponse
     */
    classes?: Array<ConfigurationHealthClassResponse>;
}

/**
 * Check if a given object implements the ConfigurationHealthResponse interface.
 */
export function instanceOfConfigurationHealthResponse(value: object): value is ConfigurationHealthResponse {
    return true;
}

export function ConfigurationHealthResponseFromJSON(json: any): ConfigurationHealthResponse {
    return ConfigurationHealthResponseFromJSONTyped(json, false);
}

export function ConfigurationHealthResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ConfigurationHealthResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'classes': json['classes'] == null ? undefined : ((json['classes'] as Array<any>).map(ConfigurationHealthClassResponseFromJSON)),
    };
}

export function ConfigurationHealthResponseToJSON(json: any): ConfigurationHealthResponse {
    return ConfigurationHealthResponseToJSONTyped(json, false);
}

export function ConfigurationHealthResponseToJSONTyped(value?: ConfigurationHealthResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'classes': value['classes'] == null ? undefined : ((value['classes'] as Array<any>).map(ConfigurationHealthClassResponseToJSON)),
    };
}

